import styled from "styled-components";

export const NoSelectionBg = styled.div`
  width: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  p {
    font-size: 14px;
    margin-top: 15px;
    font-weight: 400;
  }
`;
